import React from "react"
import { useState, useEffect } from "react"
import { collection, onSnapshot, query, where } from "firebase/firestore"
import { db } from "../firebase"
import Moment from "react-moment"
import { useAuth } from "../context/AuthContext"
import { useNavigate } from "react-router-dom"
import Navbar from "../components/Navbar"
import logo from "../assets/logo.png"

function Questions() {
  const { currentUser, room, setRoom } = useAuth()
  const [questions, setQuestions] = useState()

  useEffect(() => {
    const q = query(
      collection(db, "chats"),
      where("users", "array-contains", currentUser.email)
    )
    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (snapshot.docs.length) {
        const userDoc = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }))
        setQuestions(
          snapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }))
        )
      }
    })

    return () => unsubscribe()
  }, [])
  const navigate = useNavigate()
  const nav = (id) => {
    setRoom(id)
    navigate(`/chat/${id}`)
  }
  return (
    <div>
      <Navbar />

      <div className="container mx-auto px-4 sm:px-8 max-w-6xl">
        <div className="py-8">
          <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
            <div className="inline-block min-w-full shadow rounded-lg overflow-hidden">
              {questions ? (
                questions.map((question) => (
                  <div className="ml-4  flex-1  border-grey-lighter py-4">
                    {question.status == "active" ? (
                      <>
                        <div class="lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal ">
                          <div
                            className="transition duration-500 shadow ease-in-out transform hover:-translate-y-1 hover:shadow-lg select-none cursor-pointer"
                            onClick={() => {
                              nav(question.id)
                            }}
                          >
                            <p class="text-sm text-gray-600 flex items-center ">
                              <img
                                class="w-10 h-10 rounded-full mr-4"
                                src={logo}
                                alt="Aries Online Clinic"
                              />
                              Dr Madhumita Mazumdar
                              <span className="relative inline-block px-3 py-1 ml-auto font-semibold text-green-900 leading-tight">
                                <span
                                  aria-hidden="true"
                                  className="absolute inset-0 bg-green-200 opacity-50 rounded-full"
                                ></span>
                                <span className="relative">Active</span>
                              </span>
                            </p>

                            <div class="text-gray-900 font-bold text-xl mb-2 ">
                              {question.desc}
                            </div>
                            <p class="text-gray-700 text-base">
                              Latest Message : {question.latestMessage}
                            </p>
                            <p class="text-gray-600">
                              Last seen:
                              <Moment fromNow>
                                {Date(question.timestamp)}
                              </Moment>
                            </p>
                          </div>
                          <div class="flex items-center">
                            <div class="text-sm">
                              <p class="text-gray-900 leading-none">
                                {question.users[0]}
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div class="lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal ">
                          <div
                            className="transition duration-500 shadow ease-in-out transform hover:-translate-y-1 hover:shadow-lg select-none cursor-pointer"
                            onClick={() => {
                              nav(question.id)
                            }}
                          >
                            <p class="text-sm text-gray-600 flex items-center ">
                              <img
                                class="w-10 h-10 rounded-full mr-4"
                                src={logo}
                                alt="Aries Online Clinic"
                              />
                              Dr Madhumita Mazumdar
                              <span className="relative inline-block px-3 py-1 ml-auto font-semibold text-green-900 leading-tight">
                                <span
                                  aria-hidden="true"
                                  className="absolute inset-0 bg-red-200 opacity-50 rounded-full"
                                ></span>
                                <span className="relative">Closed</span>
                              </span>
                            </p>

                            <div class="text-gray-900 font-bold text-xl mb-2 ">
                              {question.desc}
                            </div>
                            <p class="text-gray-700 text-base">
                              Latest Message : {question.latestMessage}
                            </p>
                            <p class="text-gray-600">
                              Last seen:
                              <Moment fromNow>
                                {Date(question.timestamp)}
                              </Moment>
                            </p>
                          </div>
                          <div class="flex items-center">
                            <div class="text-sm">
                              <p class="text-gray-900 leading-none">
                                {question.users[0]}
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                ))
              ) : (
                <div
                  className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative m-auto"
                  role="alert"
                >
                  <strong className="font-bold">Sorry!</strong>
                  <span className="block sm:inline">
                    You havent asked a question yet,{currentUser.email}
                  </span>
                  <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
                    <svg
                      className="fill-current h-6 w-6 text-red-500"
                      role="button"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <title>Close</title>
                      <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                    </svg>
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Questions
